var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4453 21.6122C17.4453 20.6506 18.2248 19.8711 19.1864 19.8711C20.148 19.8711 20.9275 20.6506 20.9275 21.6122V25.9648H17.4453V21.6122Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.293 29H26.293",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0556 25.9896V16.4242H13.343V25.9896M29.3068 28.5913H30.7749C30.8854 28.5913 30.9749 28.6809 30.9749 28.7913V31.8586C30.9749 31.9691 30.8854 32.0586 30.7749 32.0586H7.6096C7.49915 32.0586 7.4096 31.9691 7.4096 31.8586V28.7913C7.4096 28.6809 7.49915 28.5913 7.6096 28.5913H9.11047L9.0867 25.9896H10.7634L10.768 16.4672L7.19772 16.4264C7.08816 16.4252 7 16.336 7 16.2264V14.4521C7 14.3863 7.03233 14.3247 7.08648 14.2874L19.0764 6.02081C19.1448 5.97368 19.2352 5.97369 19.3035 6.02083L31.2886 14.2874C31.3427 14.3247 31.375 14.3863 31.375 14.452V16.2242C31.375 16.3346 31.2855 16.4242 31.175 16.4242H27.6166V25.9896H29.2746L29.3068 28.5913Z",
    stroke: "#20242E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1864,
    cy: 12.036,
    r: 1.74107,
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredBank);
export default __webpack_public_path__ + "static/media/ic-colored-bank.02b07d7ee4fa5a0d60f4054c8195f280.svg";
export { ForwardRef as ReactComponent };